import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import content from '../../utils/content.json';

const LandAffect = () => (
  <VaDetails label={content['financial-info-land-lot-info-title']}>
    <p>
      {content['financial-info-land-lot-info-prefix']}{' '}
      <span className="vads-u-font-style--italic">may</span>{' '}
      {content['financial-info-land-lot-info-suffix']}
    </p>
  </VaDetails>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-land-lot-title']),
    homeAcreageMoreThanTwo: yesNoUI({
      title: content['financial-info-land-lot-question-default'],
      updateUiSchema: formData => ({
        'ui:title':
          formData?.claimantRelationship ===
          'CUSTODIAN_FILING_FOR_CHILD_UNDER_18'
            ? content['financial-info-land-lot-question-custodian']
            : content['financial-info-land-lot-question-default'],
      }),
    }),
    'view:landAffect': {
      'ui:description': LandAffect,
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['homeAcreageMoreThanTwo'],
    properties: {
      homeAcreageMoreThanTwo: yesNoSchema,
      'view:landAffect': {
        type: 'object',
        properties: {},
      },
    },
  },
};
